<template>
  <div class="form-page">
    <div class="cashalo-div">
      <img src="../assets/cashalo.svg" alt="">
    </div>
    <h4>Pay your Cashalo Loan safely from home</h4>
    <p>Enjoy quick and hassle-free repayments.</p>
    <div class="form-data">
      <h4>Input your loan details</h4>
      <p>Make sure all information is correct to ensure repayment is processed.</p>

      <!-- @blur="validateLoan" -->
      <form class="ui form">
        <div class="field loan">
          <input type="text"
          v-model="loanid"
          @blur="validateLoan"
          @keypress="noSChar"
          placeholder="Loan ID Number"
          pattern="^[a-zA-Z0-9]+$"
          maxlength="16">
          <label> {{ loanidtxt }} </label>
        </div>

        <div class="field mobile">
          <div class="mobile-text">+63</div>
          <input pattern="[9]{3}[09]{3}[0-9]{4}"
          @blur="validateMobile"
          @keydown="isNumber"
          v-model="mobile"
          type="tel"
          name="mobile"
          placeholder="Mobile Number"
          maxlength="10"
          id="clickmobile">
          <label>{{ mobiletxt }}</label>
        </div>

        <div class="field bank">
          <div id="bank" v-model="bank" class="ui compact selection fluid dropdown">
            <i class="dropdown icon"></i>
            <div class="default text">Select Payment Option</div>
            <div class="menu">
              <div v-for="(types, index) in banklist" class="item" @click="getdata(types)"> {{ types.banks }}</div>
            </div>
          </div>
          <label>{{ banktxt }}</label>
        </div>

        <div class="field amount">
          <input type="text"
            v-model="amount"
            maxlength="8"
            @keypress="noSCharWD"
            @focus="resetamount"
            @keydown="isNumberAmount" placeholder="Amount"
            @blur="validateAmount">

          <label>{{ amounttxt }}</label>
        </div>

        <div class="bank-charges">
          <p>The bank charges an additional service fee
            which will be added to your payment.</p>
        </div>

        <div class="recaptcha">
          <vue-recaptcha class="captcha"
            @verify="checkCaptcha"
            ref="recaptcha"
            sitekey="6LeVMcUaAAAAAI7lylb5LCtuLfZ3-YWXGiNFQwVR"
            :loadRecaptchaScript="true">
          </vue-recaptcha>
        </div>

        <div class="ui checkbox">
          <input type="checkbox" name="example">
          <label>I have read and agreed to the </label>
        </div>
        <a class="terms" @click="terms">terms and conditions.</a>

        <div class="submit-btn">
          <a v-on:click.prevent="submit"
            class="ui button orange"
            id="next"
            :class="{disabled: !checkSubmit(), orange: checkSubmit()}">
            NEXT
          </a>
        </div>

        <div class="xendit-div">
          Powered by:
          <img src="../assets/xendit.svg" alt="">
        </div>
      </form>
    </div>
    <modal-termsandcondition />
    <modal-summary />
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  components: {
    VueRecaptcha,
      'modal-termsandcondition': () => import("@/views/modals/TermsAndCondition.vue"),
      'modal-summary': () => import("@/views/modals/Summary.vue"),
   },
  name: 'formPage',
  captcha: '',
  data() {
    return {
      widgetId: 0,
      loanidtxt: 'Provide your Cashalo Credit ID or Loan ID',
      mobiletxt: 'Provide your Cashalo registered Mobile Number',
      amounttxt: 'The minimum payment is PHP 50.00',
      banktxt: 'Choose a Bank',
      loanid: '',
      mobile: '',
      captcha: '',
      amount: '',
      bank: '',
      banks: '',
      mobileValid: false,
      loanidValid: false,
      amountValid: false,
      termscheck: '',
      banklist: [
        {
          banks: 'Bank of the Philippine Island (BPI)',
          channelCode: 'BA_BPI',
        },
        // {
        //   banks: 'Bdo',
        //   channelCode: 'BA_BDO',
        // },
      ],
    };
  },
  methods: {
    noSChar(evt) {
      if(!((evt.keyCode >= 65) && (evt.keyCode <= 90) || (evt.keyCode >= 97) && (evt.keyCode <= 122) || (evt.keyCode >= 48) && (evt.keyCode <= 57))){
         evt.returnValue = false;
         return;
      }
    },

    terms() {
      this.$modal.show('modal-termsandcondition')
    },

    checkCaptcha(response) {
      if (response != null ) {
        this.captcha = true
      } else {
        this.captcha = false
      }
    },

    fixAmount() {
      if(this.amount != null || this.amount == null || this.amount == NaN || this.amount == ''){
        var n = this.amount
        this.amount = parseFloat(n).toFixed(2)
        this.addComma()
      } else {
        return false
      }
    },

    addComma() {
      var n = this.amount
      this.amount = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    resetamount() {
      if (this.amountValid) {
        this.amount = this.amount ? this.amount : 0;
        var amount = this.amount
        amount = amount.replace(/,/g, ""); // remove commas
        amount = parseFloat(amount)
        this.amount = amount
        //check if value is Nan
        if (isNaN(this.amount)) this.amount = '';
      } else {
        return false
      }
    },

    submit() {
      let formdata = {
        loanid: this.loanid,
        mobile: this.mobile,
        bank: this.bank,
        amount: this.amount,
        channelCode: this.channelCode
      }
      this.$modal.show('modal-summary', formdata)
    },

    validateLoan() {
      if(this.loanid != null){
        if(this.loanidValid = this.loanid && this.loanid != '' && this.loanid) {
          //valid loanid
          if (this.loanid[0] === 'B' || this.loanid[0] === 'b') {
            if (this.loanid.length === 16) {
              var str = this.loanid
              var res = str.substring(1,16)
              var reg = /[ `A-Za-z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~€]/
              if(reg.test(res)){
                $('.field.loan').addClass('invalid').removeClass('valid')
                this.loanidtxt = 'Error! Invalid Loan ID'
                this.loanidValid = false
              }else{
                $('.field.loan').addClass('valid').removeClass('invalid')
                this.loanidtxt =  'Provide your Cashalo Credit ID or Loan ID'
                this.loanidValid = true
              }
            } else {
              $('.field.loan').addClass('invalid').removeClass('valid')
              this.loanidtxt = 'Error! Invalid Loan ID'
              this.loanidValid = false
            }
          } else if (this.loanid[0] != 'B' || this.loanid[0] != 'b') {
            if (this.loanid.length === 15) {
              var regx = /^[0-9]*$/
              //valid credit id
              if (this.loanidValid = regx.test(this.loanid) && this.loanid != '' && this.loanid) {
                $('.field.loan').addClass('valid').removeClass('invalid')
                this.loanidtxt =  'Provide your Cashalo Credit ID or Loan ID'
                this.loanidValid = true
              } else {
                $('.field.loan').addClass('invalid').removeClass('valid')
                this.loanidtxt = 'Error! Invalid Loan ID'
                this.loanidValid = false
              }
            } else {
              $('.field.loan').addClass('invalid').removeClass('valid')
              this.loanidtxt = 'Error! Invalid Loan ID'
              this.loanidValid = false
            }
          } else {
            $('.field.loan').addClass('invalid').removeClass('valid')
            this.loanidtxt = 'Error! Invalid Loan ID'
            this.loanidValid = false
          }
        } else {
          $('.field.loan').removeClass('invalid').removeClass('valid')
          this.loanidtxt =  'Provide your Cashalo Credit ID or Loan ID'
          this.loanidValid = false
        }
      }
    },

    validateMobile() {
        var regex = /^(?:9)(?:\d(?:-)?){9}$/g;
        if(this.mobile != null){
          if(this.mobileValid = regex.test(this.mobile) && this.mobile != '' && this.mobile) {
            $('.field.mobile').removeClass('invalid').addClass('valid')
            this.mobiletxt = 'Provide your Cashalo registered Mobile Number'
            this.mobileValid = true
          } else {
            if(this.mobile) {
              //invalid mobile
              $('.field.mobile').addClass('invalid').removeClass('valid')
              this.mobiletxt = 'Error! Invalid Mobile Number'
              this.mobileValid = false
            } else {
              //no input
              $('.field.mobile').removeClass('invalid').removeClass('valid')
              this.mobiletxt = 'Provide your Cashalo registered Mobile Number'
              this.mobileValid = false
            }
          }
        } else {
          //no input
          $('.field.mobile').addClass('invalid').removeClass('valid')
          this.mobiletxt = 'Error! Invalid Mobile Number'
          this.mobileValid = false
        }
        this.checkSubmit()
      },

      validateBank () {
        if (this.bank == '' || this.bank.length == 0) {
          $('.field.bank').removeClass('valid')
        } else if (this.bank.length != 0) {
          $('.field.bank').addClass('valid')
        } else {
          $('.field.bank').removeClass('valid')
        }
      },

      validateAmount() {
        // var regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
        var regex = /^\d*\.?\d*$/
        if(this.amount != null){
          if(this.amountValid = regex.test(this.amount) && this.amount != '' && this.amount) {
            if (this.amount >= 50) {
              $('.field.amount').removeClass('invalid').addClass('valid')
              this.fixAmount()
              this.amounttxt = 'The minimum payment is PHP 50.00'
              this.amountValid = true
            } else {
              $('.field.amount').addClass('invalid').removeClass('valid')
              this.amounttxt = 'Amount to pay must not be lower than PHP 50.00'
              this.amountValid = false
            }
          } else {
            if(this.amount) {
              //invalid mobile
              $('.field.amount').addClass('invalid').removeClass('valid')
              this.amounttxt = 'Error! Invalid Amount'
              this.amountValid = false
            } else {
              //no input
              $('.field.amount').removeClass('invalid').removeClass('valid')
              this.amounttxt = 'The minimum payment is PHP 50.00'
              this.amountValid = false
            }
          }
        } else {
          //no input
          $('.field.amount').addClass('invalid').removeClass('valid')
          this.amounttxt = 'Error! Invalid Amount'
          this.amountValid = false
        }
      },

      noSCharWD(evt) {
        if (event.keyCode === 46) {
          return true
        }

        if(!((event.keyCode >= 65) && (event.keyCode <= 90) || (event.keyCode >= 97) && (event.keyCode <= 122) || (event.keyCode >= 48) && (event.keyCode <= 57))){
          event.returnValue = false;
          return;
        }
      },

      isNumberAmount(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))
        && charCode !== 46 && charCode != 190 && charCode != 110
        && (charCode > 105 || charCode < 96)) {
          evt.preventDefault();
        } else if (charCode === 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      },

      getdata(types) {
        this.bank = types.banks
        this.channelCode = types.channelCode
      },

      isNumber(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        var reg = /[ `A-Za-z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 ||
        charCode == 186 ||
        charCode == 188 ||
        charCode == 122) {
          evt.preventDefault();
        } else if (charCode === 46) {
          evt.preventDefault();
        } else if (charCode === 108) {
          evt.preventDefault();
        } else if(['(',')','/',',','*','!','@','$',
            /"""/,";","?",":","'",'"',"#","%"
            ,"^","&","_","+","|","}","{",">","<","~","`"].indexOf(evt.key) !== -1){
          evt.preventDefault();
        } else if (reg.test(charCode)) {
          evt.preventDefault();
        } else {
          return true
        }
    // //
    //     var key = evt.which || this.value.substr(-1).charCodeAt(0);
    // alert( key )

      },

    checkSubmit() {

      if(!this.mobileValid) {
        return false
      }

      if(!this.loanidValid) {
        return false
      }

      if(!this.amountValid) {
        return false
      }

      if(!this.bank) {
        return false
      }

      if(!this.captcha) {
        return false
      }

      if(!this.termscheck) {
        return false
      }
      return true
    },

    initializeDropdown() {
      const self = this
      window.setTimeout(()=>{
        $('#bank').dropdown({
          on: 'click',
          allowReselection: true,
          allowAdditions: true,
          onChange: (value, text) => {
            self.bank = value
            this.validateBank()
          },
        });
      },500)
    },

    validateCheck() {
      const self = this
      window.setTimeout(()=>{
        $('.checkbox').checkbox({
          on: 'click',
          onChecked: function() {
            self.termscheck = true
          },
          onUnchecked: function() {
            self.termscheck = false
          },
        });
      },500)
    },
  },

  mounted() {
    // console.log(process.env)
    this.initializeDropdown()
    this.validateCheck()
    //
    // console.log(window.innerWidth());
  }
}
</script>
